var Handlebars = require("../../../../../../../../../../.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "loader-fullscreen";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"loader-wrapper "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isBody : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n        <div class=\"loader-indicator "
    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"color","hash":{},"data":data}) : helper)))
    + "\" aria-live=\"polite\" aria-label=\"Do not refresh the page.\"></div>\n</div>\n        ";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/loader/src/templates/views/loader.hbs
// module id = 442
// module chunks = 9